export const Translations = {
  'en': {
    'editText': 'Edit',
    'shipToAddressText': 'Ship To This Address',
    'deleteAddressText': 'Delete Shipping Address',
    'deleteConfirmationText': 'Are you sure you want to delete this shipping address?',
    'cancelText': 'Cancel',
    'acceptText': 'Accept'
  },
  'es': {
    'editText': 'Editar',
    'shipToAddressText': 'Enviar a la Siguiente Dirección',
    'deleteAddressText': 'Eliminar dirección de envío',
    'deleteConfirmationText': '¿Seguro que quieres eliminar esta dirección de envío?',
    'cancelText': 'Cancelar',
    'acceptText': 'Aceptar'
  },
  'zh': {
    'editText': '编辑',
    'shipToAddressText': '邮寄到此地址',
    'deleteAddressText': '删除此送货地址',
    'deleteConfirmationText': '您确定要删除此送货地址吗？',
    'cancelText': '取消',
    'acceptText': '接受'
  }
};
